(() => {
  angular
    .module('gm.common.transactions')
    .factory('GmyTransactions', GmyTransactions);

  function GmyTransactions(
    $q,
    $log,
    $sce,
    gmApi,
    GmyTransactionInfo,
    GmyVaults,
    promiseCache
  ) {
    'ngInject';

    const TRANSACTION_TYPES = {
      DEPOSIT: 'deposit',
      REDEMPTION: 'redemption',
      PAYMENT: 'payment',
      LOAN: 'loan'
    };

    const TRANSACTION_TYPE_CAUSE_IDS = {
      [TRANSACTION_TYPES.DEPOSIT]: [1, 2, 3, 4, 5, 6, 7, 9, 11, 14, 31, 38, 39, 41, 43, 46],
      [TRANSACTION_TYPES.REDEMPTION]: [
        8, 10, 12, 13, 15, 16, 19, 24, 25, 26, 30, 32, 33, 37, 40, 42, 44, 45
      ],
      [TRANSACTION_TYPES.PAYMENT]: [17, 18, 20, 21],
      [TRANSACTION_TYPES.LOAN]: [50, 51],
    };

    const TRANSACTION_CAUSES = {
      PREPAID_CARD_REDEMPTION: 19,
      CHARGEBACK: 100
    };

    const _transactions = [];
    const has = Object.prototype.hasOwnProperty;

    return {
      TRANSACTION_TYPES,
      TRANSACTION_CAUSES,

      addTransaction,
      checkTransactionType,
      clean,
      getTransactionTypeCauseIds,
      hasAdditionalTransactions,
      load,
      processTransaction,
    };

    function addTransaction(transaction) {
      addOrUpdateTransaction(transaction);
      _transactions.sort(compareTx);
    }

    function addOrUpdateTransaction(transaction) {
      if (transaction.id) {
        for (let i = 0; i < _transactions.length; i += 1) {
          const existingTransaction = _transactions[i];
          if (existingTransaction.id === transaction.id) {
            angular.extend(existingTransaction, transaction);
            return false;
          }
        }
      } else {
        const existingTransaction = _transactions
        .find(t => t.causeId === transaction.causeId && t.ts === transaction.ts);
        if (existingTransaction) {
          angular.extend(existingTransaction, transaction);
          return false;
        }
      }
      _transactions.push(transaction);

      return true;
    }

    function checkTransactionType(transaction, type) {
      return this.getTransactionTypeCauseIds(type).indexOf(transaction.causeId) > -1;
    }

    function clean() {
      _transactions.splice(0, _transactions.length);
    }

    function compareTx(t1, t2) {
      return (t2.id && t1.id) ? (t2.id - t1.id) : (t2.ts - t1.ts);
    }

    function getTransactionTypeCauseIds(transactionType) {
      return has.call(TRANSACTION_TYPE_CAUSE_IDS, transactionType)
        ? TRANSACTION_TYPE_CAUSE_IDS[transactionType]
        : [];
    }

    function hasAdditionalTransactions(transactionsDisplayed) {
      return (_transactions.length > transactionsDisplayed);
    }

    function load(bustCache) {
      return loadTrades(bustCache).then(() => _transactions);
    }

    function loadTrades(bustCache) {
      return promiseCache({
        bustCache,
        ttl: 30000,
        args: [bustCache],
        promise: _bustCache => $q
          .all([
            gmApi.get('aurum/user/trades', { params: { desc: true }, auth: true }),
            gmApi.get('payments/bankWire', { auth: true }),
            GmyVaults.getVaults()
          ])
          .then(([transactions, bankWires, vaults]) => {
            const chargebackedTxIds = [];

            if ((angular.isUndefined(transactions)) || (!angular.isArray(transactions))) {
              $log.debug('Unexpected response from the API');

              return [];
            }

            const mergedTransactions = bankWires.trades
              .concat(transactions)
              .sort(compareTx)
              .map(tx => processTransaction(tx, vaults, chargebackedTxIds));

            if (_bustCache) {
              clean();
            }

            mergedTransactions.forEach(tx => addOrUpdateTransaction(tx));
            _transactions.sort(compareTx);

            return false;
          })
      });
    }

    function processTransaction(transaction, vaults, chargebackedTxIds = []) {
      transaction.parsedCauseParams = null;

      try {
        const params = transaction.causeParams && JSON.parse(transaction.causeParams);
        transaction.parsedCauseParams = params;
      } catch (e) {
        // error
      }

      transaction.description = $sce.trustAsHtml(
        GmyTransactionInfo.getTransactionCauseDescription(transaction)
      );
      transaction.vault = vaults.find(v => v.id === transaction.vaultId);
      transaction.isStatusComplete = transaction.settleStatus === 2;
      transaction.isBonus = [22, 28, 29].indexOf(transaction.causeId) !== -1;

      if (transaction.causeId === TRANSACTION_CAUSES.CHARGEBACK && transaction.parsedCauseParams) {
        chargebackedTxIds.push(transaction.parsedCauseParams.id);
      }

      if (chargebackedTxIds.indexOf(transaction.id) > -1) {
        transaction.isChargebacked = true;
      } else {
        transaction.isChargebacked = false;
      }

      return transaction;
    }
  }
})();
